module.exports = __webpack_public_path__ + "img/IMG_8994.fdbc37dd.jpg";